// A startup that fails before anything is mounted used to leave #app empty: a white page until the
// reader reloaded by hand (bug #13). The failure is logged, kept for this tab so a bug report sent
// after the reload still carries it, and -- only while nothing else is on screen -- replaced by a
// message with a reload button. Anything already rendered (login, shell) is left alone.
export const STARTUP_ERROR_KEY = 'pm-chat:startup-error';
const MAX_DETAIL = 1000;

export type StartupFailureSurface = {
  isBlank(): boolean;
  showFailure(): void;
  store(key: string, value: string): void;
  log(message: string, error: unknown): void;
};

export function describeStartupError(error: unknown): string {
  const text = error instanceof Error ? `${error.name}: ${error.message}${error.stack ? `\n${error.stack}` : ''}` : String(error);
  return text.slice(0, MAX_DETAIL);
}

export function reportStartupFailure(error: unknown, surface: StartupFailureSurface, now = new Date()): void {
  surface.log('[pm-chat] startup failed', error);
  try { surface.store(STARTUP_ERROR_KEY, JSON.stringify({ at: now.toISOString(), error: describeStartupError(error) })); }
  catch { /* Storage may be unavailable; the console entry and the fallback still apply. */ }
  if (surface.isBlank()) surface.showFailure();
}

export function readStartupFailure(read: (key: string) => string | null): unknown {
  try { const raw = read(STARTUP_ERROR_KEY); return raw ? JSON.parse(raw) as unknown : null; } catch { return null; }
}
